import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

interface UseENO1RejectOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

/**
 * Hook for rejecting eNO1 files with an optional comment
 * @param options Configuration options for the mutation
 * @returns Mutation object for rejecting files
 */
export function useENO1Reject(options: UseENO1RejectOptions = {}) {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ fileId, comment }: { fileId: number; comment?: string }) => {
      const params: Record<string, string> = {};
      
      // Only add comment parameter if provided and not empty
      if (comment && comment.trim() !== '') {
        params.comment = comment.trim();
      }
      
      const response = await axios.delete(`/data-set/eno1/${fileId}`, {
        params
      });
      return response.data;
    },
    onSuccess: (data, variables) => {
      // Invalidate related queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['eno1'] });
      queryClient.invalidateQueries({ queryKey: ['eno1-inbound'] });
      queryClient.invalidateQueries({ queryKey: ['eno1-outbound'] });
      
      // Call the onSuccess callback if provided
      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (error) => {
      // Call the onError callback if provided
      if (options.onError) {
        options.onError(error);
      }
    }
  });
} 